<script lang="ts" setup>
const router = useRouter()
router.push('/commodityManagement')
</script>
